import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCategories, restructureCategories, deleteCategory } from '../actions/CategoryActions';
import { Link } from 'react-router-dom';
import { Button, Pane, PlusIcon } from 'evergreen-ui';
import CategoryTreeManager from '../components/CategoryTreeManager';

class ListCategories extends Component {
    componentDidMount() {
        this.props.dispatch(getCategories());
    }

    handleRestructure = (newTree) => {
        this.props.dispatch(restructureCategories(newTree));
    }

    handleDelete = (id) => {
        if (window.confirm('Esti sigur ca vrei sa stergi aceasta categorie?')) {
            this.props.dispatch(deleteCategory(id));
        }
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/categories/create">
                        <Button icon={PlusIcon} intent="none" appearance="primary">
                            Categorie noua
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            
            <CategoryTreeManager
                categories={this.props.data}
                onRestructure={this.handleRestructure}
                onDelete={this.handleDelete}
                loading={this.props.loading}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.categories;
}

export default connect(mapStateToProps)(ListCategories);